module.exports = "https://la-static.vkplay.ru/promo/newstart/img/arcana.baf2da5f.png";